var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", {
        attrs: { title: "Tipo de criação pecuária e produtividade" }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Tipo de criação",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: !_vm.pratica.pecuarias.length ? "required" : "",
              opcoes: _vm.tiposCriacao,
              widthColumn: 8
            },
            model: {
              value: _vm.criacao.tipo,
              callback: function($$v) {
                _vm.$set(_vm.criacao, "tipo", $$v)
              },
              expression: "criacao.tipo"
            }
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: !_vm.pratica.pecuarias.length ? "required" : "",
              name: _vm.nomeAba + "/Qual tipo "
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _vm.containsOption(
                      _vm.criacao.tipo,
                      "OUTROS",
                      "especificacaoOutros"
                    )
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("Label", {
                              attrs: { label: "Qual tipo?", obrigatorio: true }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              class: { "input erro": errors.length },
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.criacao.especificacaoOutros,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.criacao,
                                    "especificacaoOutros",
                                    $$v
                                  )
                                },
                                expression: "criacao.especificacaoOutros"
                              }
                            }),
                            _vm._v(" "),
                            errors[0]
                              ? _c("span", { staticClass: "help erro" }, [
                                  _vm._v(" " + _vm._s(errors[0]))
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: !_vm.pratica.pecuarias.length ? "required" : "",
              name: _vm.nomeAba + "/Produtividade "
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("Label", {
                          attrs: { label: "Produtividade", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-input",
                          {
                            class: { "input erro": errors.length },
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "Número de animais",
                              clearable: "",
                              onkeypress: _vm.onlyInputNumbers
                            },
                            model: {
                              value: _vm.criacao.produtividade,
                              callback: function($$v) {
                                _vm.$set(_vm.criacao, "produtividade", $$v)
                              },
                              expression: "criacao.produtividade"
                            }
                          },
                          [
                            _c(
                              "template",
                              {
                                staticClass: "el-input-group__append",
                                slot: "append"
                              },
                              [_vm._v(_vm._s(_vm.getAppenderText))]
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            width: "100%",
            top: "20px",
            display: "flex",
            "justify-content": "flex-end"
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.disableButton,
                round: "",
                type: "primary"
              },
              on: {
                click: function($event) {
                  return _vm.btnAdicionar()
                }
              }
            },
            [_vm._v("\n      Adicionar\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
        _vm._l(_vm.pratica.pecuarias, function(l, i) {
          return _c(
            "div",
            { key: i + l.tipo },
            [
              _c("Card", {
                attrs: {
                  objeto: Object.assign({}, l, {
                    tipo: _vm.pratica.pecuarias
                      ? _vm.tiposCriacao.find(function(pecuaria) {
                          return pecuaria.id === l.tipo
                        }).nome
                      : "-"
                  }),
                  deletar: function() {
                    return _vm.btnApagar(i)
                  },
                  editar: function() {
                    return _vm.btnEditar(l, i)
                  },
                  titulo: "Pecuária"
                }
              })
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22ace991", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ace991","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/ILPF/IlpfPecuaria.vue
// module id = null
// module chunks = 